






import Vue from 'vue';
import HostedCheckoutRequestForm from '@/Payment/HostedCheckoutRequestForm';

const component = Vue.extend({
    props: {
        request: {
            required: true,
            type: Object as () => HostedCheckoutRequestForm
        }
    },
    mounted() {
        const form = this.$refs.form as any;
        form.submit();
    }
});

export default component;
